import { Participant } from '@draftkings/dk-data-layer/lib-esm/contracts';

type TeamData = {
    team1: {
        participant: Participant | undefined;
        name: string;
    };
    team2: {
        participant: Participant | undefined;
        name: string;
    };
};

/**
 * Gets team data from participants array with optional team swapping
 * @param participants - Array of participants in the event
 * @param isTeamSwap - Whether to swap the order of teams
 * @returns Object containing team1 and team2 data with participant and name
 */
export const getTeamData = (participants: Participant[] | undefined, isTeamSwap: boolean): TeamData => {
    const [first, second] = isTeamSwap ? [1, 0] : [0, 1];
    return {
        team1: {
            participant: participants?.[first],
            name: participants?.[first]?.name || ''
        },
        team2: {
            participant: participants?.[second],
            name: participants?.[second]?.name || ''
        }
    };
};
